import Layout from '@layouts/main'
import store from '@store'

const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@pages/auth/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/isAuthenticated']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    hidden:true,
    path: '/user/registration',
    name: 'registration',
    component: () => lazyLoadView(import('@pages/administration/user/registration'))
  },
  {
    hidden:true,
    path: '/resetPassword',
    name: 'reset_password',
    component: () => lazyLoadView(import('@pages/administration/user/resetPassword'))
  }
]

const homeRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    header: 'Navigation',
    icon: 'home',
    component: Layout,
    meta: { authRequired: true,title: 'Dashboard' },
    redirect: '/dashboard/index',
    leaf:true,
    children: [
      {
        path: 'index',
        name:'index',
        meta: { authRequired: true},
        component: () => lazyLoadView(import('@pages/dashboard/index'))
      }
    ],
  },
  {
    path: '/',
    name: 'home',
    header: 'Navigation',
    icon: 'home',
    component: Layout,
    meta: { authRequired: true, title: 'Dashboard' },
    redirect: '/job/index',
    hidden:true,
  }
]

const adminRoutes = [
  {
    path: '/administration',
    name: 'Administration',
    icon: 'globe',
    component: Layout,
    meta: { 
      authRequired: true,
      module: 'administration',
    },
    children: [
      {
        name: 'user',
        path: 'user',
        icon: 'user',
        meta: { 
          authRequired: true,
          module: 'user',
        },
        component: () => lazyLoadView(import('@pages/administration/user/index')),
      },
      {
        hidden: true,
        path: 'user/create',
        meta: { 
          authRequired: true,
          module: 'user.create',
        },
        component: () => lazyLoadView(import('@pages/administration/user/form')),
      },
      {
        hidden: true,
        path: 'user/edit',
        meta: { 
          authRequired: true,
          module: 'user.edit',
        },
        component: () => lazyLoadView(import('@pages/administration/user/edit')),
      },
      {
        hidden: true,
        path: 'user/view',
        meta: { 
          authRequired: true,
          module: 'user.view',
        },
        component: () => lazyLoadView(import('@pages/administration/user/view')),
      },
      {
        hidden: true,
        path: 'user/invite',
        meta: { 
          authRequired: true,
          module: 'user.invite_user',
        },
        component: () => lazyLoadView(import('@pages/administration/user/invite')),
      },
      {
        name: 'email',
        path: 'email',
        icon: 'mail',
        meta: { 
          authRequired: true,
          module: 'email',
        },
        component: () => lazyLoadView(import('@pages/administration/email/index')),
      },
      // {
      //   name: 'staging_job',
      //   path: 'staging_job',
      //   icon: 'upload-cloud',
      //   meta: { 
      //     authRequired: true,
      //     module: 'staging_job',
      //   },
      //   component: () => lazyLoadView(import('@pages/administration/staging_job/index')),
      // },
      // {
      //   name: 'webcrawler_log',
      //   path: 'webcrawler_log',
      //   icon: 'upload-cloud',
      //   meta: { 
      //     authRequired: true,
      //     module: 'webcrawler_log',
      //   },
      //   component: () => lazyLoadView(import('@pages/administration/crawler_log/index')),
      // },
      {
        name: 'role',
        path: 'role',
        icon: 'users',
        meta: { 
          authRequired: true,
          module: 'role',
        },
        component: () => lazyLoadView(import('@pages/administration/role/index')),
      },
      {
        hidden: true,
        path: 'role/create',
        meta: { 
          authRequired: true,
          module: 'role.create',
        },
        component: () => lazyLoadView(import('@pages/administration/role/create')),
      },
    ],
  },
  {
    hidden: true,
    path: '/user/confirmation',
    component: () => lazyLoadView(import('@pages/administration/user/registration')),
  },
  {
    hidden: true,
    path: '/user/step_2',
    component: () => lazyLoadView(import('@pages/administration/user/step_2')),
  },
  {
    hidden: true,
    path: '/user/step_3',
    component: () => lazyLoadView(import('@pages/administration/user/step_3')),
  },
  {
    hidden: true,
    path: '/user/step_4',
    component: () => lazyLoadView(import('@pages/administration/user/step_4')),
  },
  {
    hidden: true,
    path: '/user/step_5',
    component: () => lazyLoadView(import('@pages/administration/user/step_5')),
  },
]

const masterRoutes = [
  {
    path: '/master_files',
    name: 'master_file',
    icon: 'file-text',
    component: Layout,
    meta: { 
      authRequired: true,
      module: 'master_file',
    },
    children: [
      // {
      //   name: 'webcrawler',
      //   path: 'webcrawler',
      //   icon: 'globe',
      //   meta: { 
      //     authRequired: true,
      //     module: 'webcrawler',
      //   },
      //   component: () => lazyLoadView(import('@pages/master_files/webcrawler/index')),
      // },
      {
        name: 'Industry',
        path: 'industry',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'industry',
        },
        component: () => lazyLoadView(import('@pages/master_files/industry/index')),
      },
      {
        hidden: true,
        path: 'industry/create',
        meta: { 
          authRequired: true,
          module: 'industry.create',
        },
        component: () => lazyLoadView(import('@pages/master_files/industry/form')),
      },
      {
        hidden: true,
        path: 'industry/edit',
        meta: { 
          authRequired: true,
          module: 'industry.edit',
        },
        component: () => lazyLoadView(import('@pages/master_files/industry/form')),
      },
      {
        hidden: true,
        path: 'industry/view',
        meta: { 
          authRequired: true,
          module: 'industry.view',
        },
        component: () => lazyLoadView(import('@pages/master_files/industry/view')),
      },
      {
        name: 'Function',
        path: 'function',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'function',
        },
        component: () => lazyLoadView(import('@pages/master_files/function/index')),
      },
      {
        hidden: true,
        path: 'function/create',
        meta: { 
          authRequired: true,
          module: 'function.create',
        },
        component: () => lazyLoadView(import('@pages/master_files/function/form')),
      },
      {
        hidden: true,
        path: 'function/edit',
        meta: { 
          authRequired: true,
          module: 'function.edit',
        },
        component: () => lazyLoadView(import('@pages/master_files/function/form')),
      },
      {
        hidden: true,
        path: 'function/view',
        meta: { 
          authRequired: true,
          module: 'function.view',
        },
        component: () => lazyLoadView(import('@pages/master_files/function/view')),
      },
      {
        name: 'Brand',
        path: 'brand',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'brand',
        },
        component: () => lazyLoadView(import('@pages/brand/index')),
      },
      {
        hidden: true,
        path: 'brand/create',
        meta: { 
          authRequired: true,
          module: 'brand.create',
        },
        component: () => lazyLoadView(import('@pages/brand/form')),
      },
      {
        hidden: true,
        path: 'brand/edit',
        meta: { 
          authRequired: true,
          module: 'brand.edit',
        },
        component: () => lazyLoadView(import('@pages/brand/form')),
      },
      {
        hidden: true,
        path: 'brand/view',
        meta: { 
          authRequired: true,
          module: 'brand.view',
        },
        component: () => lazyLoadView(import('@pages/brand/view')),
      },
      {
        name: 'Currency',
        path: 'currency',
        icon: 'circle',
        meta: { 
          authRequired: true,
          module: 'currency',
        },
        component: () => lazyLoadView(import('@pages/master_files/currency/index')),
      },
      {
        hidden: true,
        path: 'currency/create',
        meta: { 
          authRequired: true,
          module: 'currency.create',
        },
        component: () => lazyLoadView(import('@pages/master_files/currency/form')),
      },
      {
        hidden: true,
        path: 'currency/edit',
        meta: { 
          authRequired: true,
          module: 'currency.edit',
        },
        component: () => lazyLoadView(import('@pages/master_files/currency/form')),
      },
      {
        hidden: true,
        path: 'currency/view',
        meta: { 
          authRequired: true,
          module: 'currency.view',
        },
        component: () => lazyLoadView(import('@pages/master_files/currency/view')),
      },
      // {
      //   name: 'source_company',
      //   path: 'source_company',
      //   icon: 'tag',
      //   meta: { 
      //     authRequired: true,
      //     module: 'source_company',
      //   },
      //   component: () => lazyLoadView(import('@pages/master_files/source_company/index')),
      // },
      // {
      //   name: 'Source Candidate',
      //   path: 'source_candidate',
      //   icon: 'archive',
      //   meta: { authRequired: true},
      //   component: () => lazyLoadView(import('@pages/master_files/source_candidate/index')),
      // },
      {
        name: 'candidate_source',
        path: 'candidate_source',
        icon: 'link',
        meta: { 
          authRequired: true,
          module: 'candidate_source',
        },
        component: () => lazyLoadView(import('@pages/master_files/candidate_source/index')),
      },
      {
        name: 'category',
        path: 'category',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'category',
        },
        component: () => lazyLoadView(import('@pages/master_files/category/index')),
      },
      {
        name: 'tag',
        path: 'tag',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'tag',
        },
        component: () => lazyLoadView(import('@pages/master_files/tag/index')),
      },
      {
        name: 'employment_type',
        path: 'employment_type',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'employment_type',
        },
        component: () => lazyLoadView(import('@pages/master_files/employment_type/index')),
      },
      {
        name: 'experience_level',
        path: 'experience_level',
        icon: 'briefcase',
        meta: { 
          authRequired: true,
          module: 'experience_level',
        },
        component: () => lazyLoadView(import('@pages/master_files/experience_level/index')),
      },
    ],
  },
]

// apps
const moduleRoutes = [
  {
    name: 'JobRoot',
    icon: 'briefcase',
    component:Layout,
    leaf:true,
    meta: { authRequired: true },
    path: '/job',
    redirect:'job/index',
    children:[
      {
        name: 'Job',
        path:'index',
        meta: { 
          authRequired: true,
          module: 'job',
        },
        component:() => lazyLoadView(import('@pages/job/index'))
      },
      {
        hidden: true,
        path: 'form',
        meta: { 
          authRequired: true,
        },
        component: () => lazyLoadView(import('@pages/job/form')),
      },
      {
        hidden: true,
        path: 'view',
        meta: { 
          authRequired: true,
          module: 'job.view',
        },
        component: () => lazyLoadView(import('@pages/job/view')),
      },
      {
        hidden: true,
        path: 'edit',
        meta: { 
          authRequired: true,
          module: 'job.edit',
        },
        component: () => lazyLoadView(import('@pages/job/components/dialogs/edit')),
      },
      {
        hidden: true,
        path: 'create',
        meta: { 
          authRequired: true,
          module: 'job.create',
        },
        component: () => lazyLoadView(import('@pages/job/components/dialogs/create')),
      },
    ]
  },
  /* {
    name: 'Recruiter',
    icon: 'users',
    component:Layout,
    meta: { authRequired: true },
    path: '/recruiter',
    redirect:'recruiter/index',
    leaf:true,
    children:[
      {
        path:'index',
        meta: { authRequired: true },
        component:() => lazyLoadView(import('@pages/recruiter/index'))
      },
      {
        hidden: true,
        path: 'edit',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/recruiter/edit')),
      },
      {
        hidden: true,
        path: 'form',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/recruiter/form')),
      },
      {
        hidden: true,
        path: 'view',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/recruiter/view')),
      },
      {
        hidden: true,
        path: 'invite',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/recruiter/invite')),
      },
      {
        hidden: true,
        path: 'step_3',
        component: () => lazyLoadView(import('@pages/recruiter/step_3')),
      },
      {
        hidden: true,
        path: 'step_4',
        component: () => lazyLoadView(import('@pages/recruiter/step_4')),
      },
    ]
  }, */
  {
    name: 'CandidateRoot',
    icon: 'users',
    component:Layout,
    meta: { authRequired: true },
    path: '/candidate',
    redirect:'candidate/index',
    leaf:true,
    children:[
      {
        path:'index',
        name: 'Candidate',
        meta: { 
          authRequired: true,
          module: 'candidate',
        },
        component:() => lazyLoadView(import('@pages/candidate/index'))
      },
      {
        hidden: true,
        path: 'form',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/candidate/form')),
      },
      {
        hidden: true,
        path: 'edit',
        meta: { 
          authRequired: true,
          module: 'candidate.edit',
        },
        component: () => lazyLoadView(import('@pages/candidate/edit')),
      },
      {
        hidden: true,
        path: 'step_3',
        component: () => lazyLoadView(import('@pages/candidate/step_3')),
      },
      {
        hidden: true,
        path: 'step_4',
        component: () => lazyLoadView(import('@pages/candidate/step_4')),
      },
      {
        hidden: true,
        path: 'view',
        meta: { 
          authRequired: true,
          module: 'candidate.view',
        },
        component: () => lazyLoadView(import('@pages/candidate/view')),
      },
    ]
  },
  {
    name: 'Exam',
    icon: 'users',
    component:Layout,
    meta: { authRequired: true },
    path: '/exam',
    redirect:'exam/index',
    leaf:true,
    children:[
      {
        name: 'exam',
        path:'index',
        meta: { 
          authRequired: true,
          module: 'exam',
        },
        component:() => lazyLoadView(import('@pages/exam/index'))
      },
      {
        path: 'create-exaam',
        name: 'CreateExamPage',
        meta: {
          authRequired: true,
          // module: 'exam.create',
        },
        component: () => lazyLoadView(import('@pages/exam/CreateExamPage')),
      },
      {
        path: 'take-exam/:id',
        name: 'TakeExamPage',
        meta: { 
          authRequired: true,
          // module: 'exam.take',
        },
        component:() => lazyLoadView(import('@pages/exam/TakeExamPage'))
      },
      {
        path: 'manual-grading-exam',
        name: 'ManualGradingPage',
        meta: {
          authRequired: true,
          // module: 'exam.manual-grading',
        },
        component: () => lazyLoadView(import('@pages/exam/ManualGradingExamPage')),
      }
    ]
  },
  {
    name: 'Interview',
    icon: 'users',
    component:Layout,
    meta: { authRequired: true },
    path: '/interview',
    redirect:'interview/index',
    leaf:true,
    children:[
      {
        path:'index',
        name:'interview',
        meta: {
          authRequired: true,
          // module: 'interview',
        },
        component:() => lazyLoadView(import('@pages/interview/index'))
      },
    ]
  },
  {
    hidden: true,
    path: '/company/candidates',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@pages/company/candidates')),
  },
  {
    hidden: true,
    path: '/candidate/schedule',
    meta: { authRequired: true },
    component: () => lazyLoadView(import('@pages/candidate/schedules')),
  },
  {
    hidden: true,
    path: '/candidate/acknowledgement',
    // meta: { authRequired: true },
    component: () => lazyLoadView(import('@pages/candidate/acknowledge')),
  },
  {
    hidden: true,
    path: '/candidate/viewJob',
    /* meta: { authRequired: true }, */
    component: () => lazyLoadView(import('@pages/candidate/viewJob')),
  },
  {
    hidden: true,
    path: '/candidate/jobOffer',
    /* meta: { authRequired: true }, */
    component: () => lazyLoadView(import('@pages/candidate/jobOffer')),
  },
  {
    name: 'ApplicationRoot',
    icon: 'user-check',
    component:Layout,
    meta: { authRequired: true },
    path: '/application',
    redirect:'application/index',
    leaf:true,
    children:[
      {
        path:'index',
        name:'Application',
        meta: { 
          authRequired: true,
          module: 'application',
        },
        component:() => lazyLoadView(import('@pages/application/index'))
      },
      {
        hidden: true,
        path: 'view',
        meta: { 
          authRequired: true,
          module: 'application.view',
        },
        component: () => lazyLoadView(import('@pages/application/view')),
      },
    ]
  },
  {
    name: 'CompanyRoot',
    icon: 'map-pin',
    meta: { authRequired: true },
    leaf:true,
    component:Layout,
    path: '/company',
    redirect:'company/index',
    children:[
      {
        path:'index',
        name: 'Company',
        meta: { 
          authRequired: true,
          module: 'company',
        },
        component:() => lazyLoadView(import('@pages/company/index'))
      },
      {
        hidden: true,
        path: 'edit',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/company/form')),
      },
      {
        hidden: true,
        path: 'create',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/company/form')),
      },
      {
        hidden: true,
        path: 'view',
        meta: { authRequired: true },
        component: () => lazyLoadView(import('@pages/company/view')),
      }
    ]
  },
  {
    name: 'Financing',
    icon: 'bar-chart-2',
    component: Layout,
    path: '/finance',
    redirect:'finance/index',
    leaf:true,
    hidden:true,
    children:[
      {
        path:'index',
        meta: { authRequired: true },
        component:() => lazyLoadView(import('@pages/finance/index'))
      }
    ]
  },
  {
    name: 'Calendar',
    icon: 'calendar',
    component: Layout,
    path: '/calendar',
    redirect:'calendar/index',
    leaf:true,
    children:[
      {
        path:'index',
        meta: { authRequired: true },
        component:() => lazyLoadView(import('@pages/calendar/index'))
      }
    ]
  },
  /* ,
  {
    name: 'Settings',
    icon: 'settings',
    component: Layout,
    path: '/calendar',
    redirect:'calendar/index',
    leaf:true,
    children:[
      {
        path:'index',
        meta: { authRequired: true },
        component:() => lazyLoadView(import('@pages/calendar/index'))
      }
    ]
  } */
];

const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    component: require('@views/error/error404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/error/error500').default,
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];

const userSignupRoutes = [
  {  
    path: '/user_signup',
    name: 'User Signup',
    component: require('@pages/user_signup').default,
    props: route => ({ recruiter: route.query.recruiter }),
    beforeEnter: (to, from, next) => {
      if (!to.query.recruiter) {
        next({ name: '404', params: { resource: 'Recruiter ID' } });
      } else {
        next();
      }
    }
  }
];


const authProtectedRoutes = [
  ...homeRoutes,
  ...adminRoutes,
  ...masterRoutes,
  ...moduleRoutes,
/*   ...userSignupRoutes,
 */]

const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes, ...userSignupRoutes]

export {allRoutes, authProtectedRoutes}

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@components/_loading').default,
    /* delay: 400, */
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}